import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=b54c7b66&scoped=true&"
import script from "./DeliveryForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=b54c7b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54c7b66",
  null
  
)

export default component.exports